import React from 'react'
import { connect } from 'react-redux'

import Header from './header.react.js'
import Footer from './footer.react.js'
import ShopMenu from './shopmenu.react.js'
import ShopList from './shoplist.react.js'
import {set_filter} from '../actions'
import {AREA, CATEGORY} from '../defines.js'


const App = React.createClass({
  setmetainfo() {
    var areaid = this.props.location.query.areaid
    if (!areaid)  {
      areaid = '1'
    }
    var categoryid = this.props.location.query.categoryid
    if (!categoryid)  {
      categoryid = '1'
    }

    const desc=`【${AREA[areaid]}|${CATEGORY[categoryid]}】`

    $('meta[name=description]').remove();
    $('head').append(`<meta name="description" content="池袋紳士${desc} - 一番見やすい池袋風俗情報サイト。お気に入り嬢の出勤情報をひと目で確認!">`);
    document.title = `池袋紳士${desc} - 一番見やすい池袋風俗情報サイト`
  },

  componentDidMount() {
    this.setmetainfo()
    this.props.set_filter(this.props.location.query)

  },
  componentDidUpdate() {
    this.setmetainfo()
    this.props.set_filter(this.props.location.query)
  },

  render() {
    return (
      <div>
        <Header />

        <div className='container-fluid'>

          <div className='row'>
            <div className='col-sm-3'>
              <ShopMenu/>
            </div>
            <div className='col-sm-9'>
              <ShopList/>
            </div>
          </div>
        </div>

        <Footer/>
      </div>
    )
  }
})

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = {
  set_filter
}

export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./components/Summary.react.js